<template lang="html">
  <div :id="'pagination' + randomId" class="pagination__wrp">
    <ul class="pagination" v-if="pages.length > 1" :class="{ 'mt-0': disableInnerMargin }">
      <li
        :style="colorStyle"
        class="pg__item prev__item"
        :class="{ disabled: activePage === 1 }"
        @click="activePage !== 1 && setPage(activePage - 1)"
      >
        <span class="page-link">Назад</span>
      </li>

      <li
        v-for="(item, index) in pages"
        :key="index"
        class="pg__item"
        :style="colorStyle"
        :class="{
          'pagination_active': activePage === item,
          'page-item': item !== '...',
          'dot-item': item === '...',
        }"
        @click="item !== '...' && activePage !== item && setPage(item)"
      >
        <span class="page-link">{{ item }}</span>
      </li>

      <li
        :style="colorStyle"
        class="pg__item next__item"
        :class="{ disabled: activePage === totalPages }"
        @click="activePage !== totalPages && setPage(activePage + 1)"
      >
        <span class="page-link">Вперед</span>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'bimPagination',
    props: {
      /**
       * Сколько всего страниц
       */
      totalPages: {
        type: Number,
        default: 0,
      },
      /**
       * Какая страница сейчас активная
       */
      activePage: {
        type: Number,
        default: 0
      },
      /**
       * Задает класс элемента, который нужно прокручивать
       */
      parentClass: String,
      /**
       * Селектор, до какого класса нужно прокрутить.
       * Например: body, .someClass, #someId и т.д. Главное чтобы был уникальным, иначе будет ошибка
       */
      scrollTo: String,
      /**
       * Отключение прокрутки при клике
       */
      scrollOff: Boolean,
      /**
       * Основной цвет
       */
      primaryColor: {
        type: String,
        default: '#00afa1'
      },
      disableInnerMargin: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      colorStyle () {
        return {
          '--primarycolor': this.primaryColor,
        }
      },
      randomId () {
        return Math.floor(Math.random() * (999 - 1) + 1)
      },
      pages () {
        const { totalPages, activePage } = this
        const pages = []
        const pageWidth = typeof window === 'undefined' ? 540 : window.innerWidth
        const countPageButtons = pageWidth > 767 ? pageWidth > 959 ? 7 : 6 : 5
        // кол-во кнопок переключения страниц

        if (totalPages <= 1) {
          return pages
        }

        // всего страниц очень мало - не будем проглатывать страницы
        if (totalPages <= countPageButtons) {
          for (let i = 1; i <= totalPages; i++) {
            pages.push(i)
          }

          // мы где то вначале
        } else if (activePage <= (countPageButtons / 2)) {
          for (let i = 1; i <= (countPageButtons - 1); i++) {
            pages.push(i)
          }
          pages.push('...')
          pages.push(totalPages)

          // мы где то вконце
        } else if (activePage >= totalPages - (countPageButtons / 2)) {
          pages.push(1)
          pages.push('...')

          for (let i = totalPages - (countPageButtons - 2); i <= totalPages; i++) {
            pages.push(i)
          }

          // мы где то в середине
        } else {

          const btnCount = ((countPageButtons - 2) / 2)
          let from = 0
          let to = 0

          if (btnCount % 2 === 0) {
            from = activePage - btnCount
            to = activePage + btnCount
          } else {
            from = activePage - parseInt(btnCount, 10)
            to = activePage + parseInt(btnCount, 10) + 1
          }

          pages.push(1)
          pages.push('...')

          for (let i = from; i < to; i++) {
            pages.push(i)
          }

          pages.push('...')
          pages.push(totalPages)
        }

        return pages
      },
    },
    methods: {
      setPage (page) {
        if (!this.scrollOff) { this.scrollPageToTopParent() }
        /**
         * Возвращает активную страницу
         */
        this.$emit('changePage', page)
      },
      scrollPageToTopParent () {
        const wrapper = this.parentClass ? document.querySelector(`.${this.parentClass}`) : window, // элемент, который нужно прокручивать
          parentPagination =
            document.querySelector(this.scrollTo) || document.getElementById('pagination' + this.randomId).parentElement,
          // родитель, в котором находится блок пагинации
          topCoordParentPagination = parentPagination.getBoundingClientRect().top + window.pageYOffset // вычисляем координаты родителя;

        // Прокручиваем окошко до верхней координаты. Так же вычитаем 64px - высота шапки.
        wrapper.scrollTo({
          top: topCoordParentPagination - 64,
          behavior: 'smooth'
        })
      },
    },
    mixin (dataProp, limit = 20) {
      return {
        data () {
          return {
            currentPage: 1
          }
        },
        computed: {
          paginatedData () {
            const start = (this.currentPage - 1) * limit
            return this[dataProp].slice(start, start + limit)
          },
          totalPages () {
            return Math.ceil((this.totalCount || 0) / limit)
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .pagination__wrp {
    text-align  : center;
    user-select : none;
  }

  .pagination {
    display         : flex;
    justify-content : center;
    flex            : 0;
    flex-wrap       : nowrap;
    margin          : 0;
    margin-top      : 24px;
    padding         : 0;

    list-style-type : none;

    li {
      float            : left;
      height           : 54px;

      font-weight      : bold;
      font-size        : 14px;
      line-height      : 54px;

      background-color : transparent;
      color            : $black-color;
      border-radius    : 5px;
      cursor           : pointer;

      transition       : box-shadow 0.15s, background-color 0.15s;

      &:hover {
        background-color : $white-color-100;
        color            : var(--primarycolor);
        // box-shadow: 0 20px 40px 0 rgba(0, 0, 0, 0.15);
      }

      &:active {
        background-color : $white-color-500;
        color            : var(--primarycolor);
        box-shadow       : none;
      }
    }

    &:after {
      content : '';

      display : block;
      clear   : both;
    }

    .dot-item.dot-item {
      width            : 32px;
      font-weight      : normal;

      background-color : transparent;
      box-shadow       : none !important;
      pointer-events   : none;
      @media screen and (max-width : $breakpoint-md) {
        width : 13px;
      }
    }

    .pagination_active.pagination_active {
      color            : var(--primarycolor);
      box-shadow       : none;
      cursor           : default;
      position: relative;
      z-index: 2;
    }

    .pagination_active.pagination_active:hover {
      background-color: transparent;
    }

    .pagination_active.pagination_active:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 54px;
      height: 54px;
      background-color : var(--primarycolor);
      opacity: 0.1;
      border-radius    : 5px;
      z-index: 1;
    }

    .disabled.disabled {
      opacity          : 0.5;
      color            : $black-color;

      background-color : transparent;
      box-shadow       : none;
      cursor           : not-allowed;
    }
  }

  .page-item {
    width      : 54px;

    text-align : center;
  }

  .page-item + .page-item {
    margin-left : 14px;
    @media screen and (max-width : $breakpoint-md) {
      margin-left : 2px;
    }
  }

  .prev__item,
  .next__item {
    width : 142px;
    @media screen and (max-width : $breakpoint-md) {
      display : none;
    }
  }

  .prev__item {
    margin-right : auto;
  }

  .next__item {
    margin-left : auto;
  }

  .button__form {
    margin-top : 32px;
  }

  .pg__item {
    flex : 0 0 auto;
  }
</style>
